import { render, staticRenderFns } from "./Kong.vue?vue&type=template&id=08233968&scoped=true&"
import script from "./Kong.vue?vue&type=script&lang=js&"
export * from "./Kong.vue?vue&type=script&lang=js&"
import style0 from "./Kong.vue?vue&type=style&index=0&id=08233968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08233968",
  null
  
)

export default component.exports